import * as React from 'react';
import {
    DateField,
    TextField,
    EditButton,
    TextInput,
    FunctionField,
    SelectInput,
} from 'react-admin';
import { DateRangeInput } from '../../components/input';
import { StatusEnum } from '../../common/enum';
import { PromotionTypeEnum } from 'src/common/enum/PromotionTypeEnum';
import { Datagrid, List, IfCanAccess } from 'src/enterprise/ra-rbac';

const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />,
    <SelectInput source="type" choices={PromotionTypeEnum} />,
    <SelectInput source="status" choices={StatusEnum} />,
    <DateRangeInput label='From Date' source={'from_date'}/>,
    <DateRangeInput label="To Date" source={'to_date'}/>
];

export const PromotionList = props => (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="code" />
            <FunctionField label="Type" render={record => PromotionTypeEnum.find(x => x.id === record.type)?.name}/>
            <DateField source="from_date" label="From"/>
            <DateField source="to_date" label="To"/>
            <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
            <IfCanAccess action="edit">
                <EditButton />
            </IfCanAccess>
        </Datagrid>
    </List>
);